export default function () {
  class StickyInfo extends HTMLElement {
    constructor() {
      super();

      this.navHeight = document.querySelector('[data-site-header]').getBoundingClientRect().height || 0;
      this.speedScroll = parseInt(this.getAttribute('data-speed'));
      this.minTop = parseInt(this.getAttribute('data-min-top'));
      this.headerHeight = this.navHeight;
      this.oldPosition = window.scrollY;
      this.windowHeight = window.innerHeight;
      this.infoHeight = this.getBoundingClientRect().height;
      this.differentHeights = this.windowHeight - this.infoHeight + this.headerHeight + 25;
      this.init();
    }

    init() {
      if (this.differentHeights < this.minTop) {
        if (this.oldPosition > this.differentHeights) {
          this.style.top = `${this.windowHeight - this.infoHeight}px`
        } else {
          this.style.top = `${this.oldPosition}px`
        }
      }

      window.addEventListener('scroll', () => {
        const computedStyle = window.getComputedStyle(this);
        const position = computedStyle.position;

        if (position !== 'sticky') return;

        this.currentPosition = window.scrollY;
        this.infoHeight = this.getBoundingClientRect().height;
        this.windowHeight = window.innerHeight;

        if (this.currentPosition > this.oldPosition) {
          let elTop = parseFloat(this.style.top.replace("px", ""))

          if (elTop > this.windowHeight - this.infoHeight - this.minTop) {
            this.style.top = `${elTop - this.speedScroll}px`
          }
        } else if (this.currentPosition < this.oldPosition) {
          let elTop = parseFloat(this.style.top.replace("px", ""))

          if (elTop < this.minTop) {
            this.style.top = `${elTop + this.speedScroll}px`;
          }
        }
        this.oldPosition = window.scrollY;
      })
    }
  }

  customElements.define('sticky-info', StickyInfo);
}
